const CONTAINED = 'contained';
const TEXT = 'text';
const OUTLINED = 'outlined';

export {
    CONTAINED,
    TEXT,
    OUTLINED,
};
